import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';
import { TokenExtension } from '@utils/extensions/token.extension.ts';
import { IS_ON_PREM } from '@utils/constants/app-constants.ts';

interface PlatformsResponse {
  result: { id: string }[];
}

async function fetchAllowedPlatforms(): Promise<string[]> {
  const { data } = await Axios.get<PlatformsResponse>(
    GET_URL().connectionPlatforms
  );
  return data.result.map(platform => platform.id);
}

/**
 * Platform ids Scriptix staff allow this organization to connect. The
 * backend already hides the others, so this is exactly the wizard's
 * picker. ``undefined`` while loading or on error: the picker then shows
 * everything and the server still refuses a blocked platform.
 */
export function useGetAllowedPlatforms(enabled: boolean = true) {
  return useQuery<string[], AxiosError<{ detail?: string }>>(
    QueryKeys.connectionPlatforms(),
    fetchAllowedPlatforms,
    {
      enabled: enabled && !!TokenExtension.get()?.string && !IS_ON_PREM,
      useErrorBoundary: false,
      retry: false,
      staleTime: 1000 * 60,
      refetchOnWindowFocus: false
    }
  );
}
